import React, { Component } from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import bannerImage from "../../Images/Banner/honarable-banner.webp";
import visitor from "../../Images/Hon'ble Persons/Hon’ble Shri Raman Deka.webp"

const AboutUs = () => {
    return (
        <>
            <title>Honorable Visitors | Esteemed Guests at ISBM University</title>
            <meta
                name="description"
                content="Discover esteemed visitors at ISBM University. Explore insights from industry leaders, academicians, and experts shaping education. Learn more today!"
            />

            <meta
                name="SearchEngines"
                content="Google, Bing, Overture, Yahoo, AOL, Infoseek, LookSmart, Excite, Hotbot, Lycos, CNET,
        DogPile, Ask Jeeves, Teoma, Snap, WebCrawler, AltaVista, GigaBlast, isoHunt, Kayak, MetaCrawler"
            />
            <meta name="Robots" content="INDEX, FOLLOW" />
            <meta name="Author" content="ISBM University, isbmuniversity.edu.in/" />
            <meta name="Robots" content="INDEX,ALL" />
            <meta name="YahooSeeker" content="INDEX, FOLLOW" />
            <meta name="msnbot" content="INDEX, FOLLOW" />
            <meta name="googlebot" content="Default, follow" />
            <meta name="owner" content="isbmuniversity.edu.in/" />
            <meta name="language" content="English" />
            <meta name="revisit-after" content="2 days" />
            <meta
                property="og:title"
                content="Hon'ble Visitor of ISBM University "
            />
            <meta
                property="og:description"
                content="Mr. Biswabhusan Harichandan is The Hon'ble Visitor of ISBM University. Explore ISBM University a hallmark of recognized excellence in quality and affordable education."
            />
            <meta
                property="og:url"
                content="https://isbmuniversity.edu.in/honorable/"
            />
            <meta
                property="og:image"
                content="https://isbmuniversity.edu.in/static/media/commb.0f9333e0.jpg"
            />
            <meta property="og:image:alt" content="ISBM University" />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="ISBM University" />
            <meta
                name="twitter:title"
                content="Hon'ble Visitor of ISBM University"
            />
            <meta
                name="twitter:description"
                content="Mr. Biswabhusan Harichandan is The Hon'ble Visitor of ISBM University. Explore ISBM University a hallmark of recognized excellence in quality and affordable education."
            />
            <meta
                name="twitter:image:src"
                content="https://isbmuniversity.edu.in/static/media/commb.0f9333e0.jpg"
            />
            <meta name="twitter:card" content="summary" />
            <meta name="twitter:site" content="@ISBMUniversity" />
            <meta name="twitter:creator" content="@ISBMUniversity" />
            <meta name="twitter:domain" content="https://isbmuniversity.edu.in/" />
            <meta property="twitter:account_id" content="758619542734053376" />
            <meta
                name="keywords"
                content="Professional Degrees , Recognized University , Accredited College"
            />
            <Topnav />
            <section
                className="section-hero-banner ptb-50"
                style={{
                    backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
                }}
            >
                <div className="banner-hero-overlay">
                    <div className="container-xxl">
                        <div className="section-hero-content">
                            <h1>Hon'ble Visitor</h1>
                            <ol className="breadcrumb mt-3 text-center mb-0">
                                <li className="breadcrumb-item">
                                    <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                                        Home
                                    </a>
                                </li>
                                <li
                                    className="breadcrumb-item active text-white"
                                    aria-current="page"
                                >
                                    Hon'ble Visitor
                                </li>
                                <hr className="section-divider" />
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            <section className="vc-section ptb-50">
                <div className="container-xxl">
                    <div className="vc-container">
                        <div className="vc-image-container">
                            <div className="vc-image-wrapper shadow-sm">
                                <img src={visitor} alt="Prof. (Dr.) Anand Mahalwar" className="vc-image" />
                                <div className="vc-image-overlay"></div>
                            </div>
                            <div className="vc-title-box">
                                <span className="vc-designation">Hon'ble Visitor</span>
                                <h2 className="vc-name">Hon’ble Shri Raman Deka</h2>
                            </div>
                        </div>

                        <div className="vc-content">
                            <div className="vc-message">
                                <p>
                                    <span className="fw-bold">Hon’ble Shri Raman Deka Ji</span> serving as the Governor of Chhattisgarh, bringing with him a wealth of experience and dedication to public service. As a prominent political leader, Shri Raman Deka Ji has a distinguished career, marked by his commitment to the development and welfare of the people. His tenure as Governor is characterized by initiatives aimed at improving governance, enhancing infrastructure, and fostering economic growth in the state.
                                </p>
                                <div className="vc-highlight-box fw-semibold">
                                    <p>
                                        Shri Raman Deka Ji leadership is pivotal in addressing key issues such as education, healthcare, and rural development, ensuring that the benefits of progress reach every segment of society. His collaborative approach with various stakeholders, including government officials, industry leaders, and civil society, underscores his vision of a prosperous and inclusive Chhattisgarh.
                                    </p>
                                </div>
                                <p className="p-0">
                                    Through his efforts, Hon’ble Shri Raman Deka Ji continues to play a crucial role in steering the state towards sustainable development and socio-economic advancement. He significantly influences the state’s development trajectory. His tenure is marked by a blend of visionary leadership, pragmatic governance, and a deep-seated commitment to public welfare. As Governor, Shri Raman Deka has been instrumental in implementing policies and initiatives that aim to transform Chhattisgarh into a model state in India.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default AboutUs;
